import styles from './Common.module.css'

type Variant = 'default' | 'success' | 'warning' | 'error' | 'info'

interface StatusBadgeProps {
  label: string
  variant?: Variant
}

const statusVariantMap: Record<string, Variant> = {
  draft: 'default',
  active: 'success',
  on_hold: 'warning',
  completed: 'success',
  cancelled: 'error',
  sent: 'info',
  accepted: 'success',
  rejected: 'error',
  expired: 'warning',
  converted: 'info',
  received: 'info',
  validated: 'info',
  acknowledged: 'info',
  in_production: 'warning',
  ready_to_ship: 'success',
  shipped: 'success',
  delivered: 'success',
}

export function StatusBadge({ label, variant }: StatusBadgeProps) {
  const v = variant || statusVariantMap[label] || 'default'
  return (
    <span className={`${styles.badge} ${styles[`badge_${v}`]}`}>
      {label.replace(/_/g, ' ')}
    </span>
  )
}
